import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { catchError, map, Observable, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { CountryLanguage } from '../models/country-language.model';
import { DataVariable } from '../models/data-variable.model';
import { HttpConstants } from '../models/http.constants';
import { TenantSettings } from '../models/tenant-settings.interface';
import { TenantSystemSettings } from '../models/tenant-system-settings.interface';

@Injectable({ providedIn: 'root' })
export class SystemService {
  defaultLanguage$ = toSignal(this.getTenantSettings().pipe(map((settings) => settings.defaultLanguage)), { initialValue: '' });

  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  getSystemDataVariables(): Observable<DataVariable[]> {
    return this.http.get<DataVariable[]>(`${this.environment.endPoint}configs/data-variable-type-cfg`, {
      headers: { [HttpConstants.CacheIntercept]: 'DATAVARIABLES' }
    });
  }

  getTenantSettings(): Observable<TenantSettings> {
    return this.http.get<TenantSettings>(`${this.environment.endPoint}configs/tenant-settings`);
  }

  getTenantSystemSettings(): Observable<TenantSystemSettings> {
    return this.http.get<TenantSystemSettings>(`${this.environment.endPoint}configs/system-settings`);
  }

  updateTenantSystemSettings(payload: Partial<TenantSystemSettings>): Observable<boolean> {
    return this.http.patch<TenantSystemSettings>(`${this.environment.endPoint}configs/system-settings`, payload).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  getAllDataVariables(): Observable<DataVariable[]> {
    return this.http.get<DataVariable[]>(`${this.environment.endPoint}configs/data-variable-type-cfg`);
  }

  testEmailSettings(): Observable<boolean> {
    return this.http.post<void>(`${this.environment.endPoint}configs/system-settings/email/test`, {}).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  getCountriesAndLanguages(): Observable<CountryLanguage[]> {
    return this.http.get<CountryLanguage[]>(`${this.environment.endPoint}configs/countries-and-languages`).pipe(catchError(() => of([])));
  }
}
